import { get } from "lodash"
import { makeStyles } from "@material-ui/core/styles"
import { useSelector } from "react-redux"
import { withComma, fixed2 } from "src/features/Utils/price"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import Divider from "@material-ui/core/Divider"
import Grid from "@material-ui/core/Grid"
import moment from "moment"
import Paper from "@material-ui/core/Paper"
import Box from "@material-ui/core/Box"
import React from "react"
import Typography from "@material-ui/core/Typography"

import NoImage from "src/assets/no-image.jpg"

const useStyles = makeStyles((theme) => ({
  root: { marginTop: theme.spacing(2) },
  card_root: { padding: theme.spacing(2), height: "100%" },
  avatar: {
    width: 80,
    height: 80,
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  marginBottom: theme.spacing(2),
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  bold: { fontWeight: 600 },
  action: { marginTop: theme.spacing(3) },
  btn: { borderRadius: 20 },
}))

const PromoItem = ({ promo, active }) => (
  <Grid container>
    <Grid item xs={10}>
      <Typography
        variant="caption"
        component="p"
        color={active ? "secondary" : "inherit"}
        gutterBottom
      >
        {moment(promo.start_date).format("DD/MM/YYYY")} -{" "}
        {moment(promo.end_date).format("DD/MM/YYYY")}
      </Typography>
    </Grid>
    <Grid item xs={2}>
      <Typography
        variant="caption"
        component="p"
        color={active ? "secondary" : "inherit"}
        gutterBottom
      >
        ฿{withComma(fixed2(promo.promo_price))}
      </Typography>
    </Grid>
  </Grid>
)

const sort_promos = (promotions) =>
  promotions
    .slice()
    .sort((a, b) => new Date(a.start_date) - new Date(b.start_date))

export default function CustomizedTables() {
  const classes = useStyles()
  const list = useSelector((state) => state.supply.list)

  const active_promo = (promotion) =>
    promotion.find((promo) => promo.status === "active")

  const upcoming_promo = (promotion) =>
    promotion.filter((promo) => promo.status === "upcoming").slice(0, 2)

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        {list.map((item, key) => (
          <Grid item xs={12} sm={12} md={6} lg={4} key={key}>
            <Paper elevation={0} className={classes.card_root}>
              <Box display="flex">
                <Avatar
                  className={classes.avatar}
                  variant="rounded"
                  src={item.cover_img || NoImage}
                />
                <div>
                  <Typography variant="body1" gutterBottom>
                    {get(item, "supply.search_name")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    ฿{withComma(fixed2(get(item, "price")))}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {get(item, "multiplier")} / {get(item, "container.name")}
                  </Typography>
                  <Typography variant="body2">{item.barcode}</Typography>
                </div>
              </Box>
              <Typography variant="body2" className={classes.bold} gutterBottom>
                Active
              </Typography>
              {!!active_promo(item.promotion) ? (
                <PromoItem active promo={active_promo(item.promotion)} />
              ) : (
                "-"
              )}
              <Divider className={classes.divider} />
              <Typography variant="body2" className={classes.bold} gutterBottom>
                Upcoming
              </Typography>
              {upcoming_promo(item.promotion).length
                ? sort_promos(upcoming_promo(item.promotion)).map(
                    (promo, key) => <PromoItem promo={promo} key={key} />
                  )
                : "-"}
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                className={classes.action}
              >
                <Typography variant="body2" color="textSecondary">
                  ● {item.station.full_name}
                </Typography>
                <Button
                  variant="contained"
                  target="_blank"
                  href={`/supply/${item._id}`}
                  disableElevation
                  className={classes.btn}
                >
                  MANAGE
                </Button>
              </Grid>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
